import type { GetNotificationSettingsResponse } from "../../shared/payloads/notificationSettingsPayloads";

export const getMinVisitors = (data: GetNotificationSettingsResponse) => {
  if (data.type === "visitorSummary" && data.minVisitors !== undefined) {
    return data.minVisitors;
  }
  if (
    data.type === "registrationSummary" &&
    data.minRegistrations !== undefined
  ) {
    return data.minRegistrations;
  }
  if (data.type === "orderSummary" && data.minOrders !== undefined) {
    return data.minOrders;
  }
  return 1;
};
